import { Content, Dialog, Pane } from '@leverege/ui-elements';
import React, { useCallback } from 'react';
import S from './SalesFlowLocatorSearch.css';
import DeviceSearch from '../../../r4k/views/keyTagPairing/DeviceSearch';
import C from '../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SalesFlowTagSearch(props) {
  const {
    onClose,
    show,
    actions,
    onChange,
    knowTags,
    tagBlueprint
  } = props;
  const nOnChange = useCallback(evt => {
    onChange({
      data: {
        tag: 'tag',
        tagId: 'tagId',
        tagSerial: 'tagSerial',
        sell: 'sell',
        tagNumber: 'tagNumber',
        tagSaleStatus: 'tagSaleStatus'
      },
      value: {
        tag: evt.original,
        tagId: evt.value,
        tagSerial: evt.original.data.serialNumber,
        sell: true,
        tagNumber: evt?.data,
        tagSaleStatus: knowTags ? C.TAG_SALE_STATUS.VERIFIED : C.TAG_SALE_STATUS.UNVERIFIED
      }
    });
    onClose();
  }, [onChange, onClose]);
  const getSearchText = useCallback(selected => {
    return selected?.name || selected?.data?.serialNumber;
  }, []);
  return /*#__PURE__*/_jsx(Dialog, {
    animation: "fade",
    onClose: onClose,
    show: show,
    position: "center",
    children: /*#__PURE__*/_jsx(Pane, {
      className: S.container,
      children: /*#__PURE__*/_jsx(Content, {
        children: /*#__PURE__*/_jsx(DeviceSearch, {
          ...props,
          getSearchText: getSearchText,
          actions: actions.parent(),
          onChange: nOnChange,
          onClick: onClose,
          networkId: tagBlueprint?.getTagsStartingWith('network:', true)[0]
          // disabledConditions={DISABLED_CONDITIONS}
          ,
          titleVariant: "dialogTitle",
          titleIcon: "https://recovr-ui-assets.storage.googleapis.com/pair_title_icon.png"
        })
      })
    })
  });
}